import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isUserLogged: boolean = false;

  constructor(private keycloakSrv: KeycloakService) {}

  ngOnInit(): void {
    this.setUserAuth();
  }

  setUserAuth() {
    from(this.keycloakSrv.isLoggedIn()).subscribe((auth) => {
      this.isUserLogged = auth;
    });
  }
}
